export default __webpack_public_path__ + "static/imgCosmetic-9aa3871c20168a260103408845adbedd.webp";